export default function ResourceSearchResult(
  resources = [],
  isExactMatch = false,
  currentPage = 0,
  hasNextPage = false
) {
  return {
    resources: resources,
    isExactMatch: isExactMatch,
    currentPage: currentPage,
    hasNextPage: hasNextPage,
  };
}
